import styled from 'styled-components';

import { breakpoints, Row, SkeletonElement } from '@notino/react-styleguide-v20';

import { PAGE_MAX_WIDTH } from '@styles/constants';

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0 1.5rem 0;
`;

export const StyledSubTitleWrapper = styled.div`
  display: flex;
  justify-content: left;
  margin: 2rem 0 1.5rem 0;
`;

export const StyledTitle = styled(SkeletonElement)`
  height: 2rem;

  @media (min-width: ${breakpoints.lg}) {
    height: 2.75rem;
  }
`;

export const StyledSummaryWrapper = styled(Row)`
  justify-content: center;
`;

export const StyledSummary = styled(SkeletonElement)`
  height: 3rem;

  @media (min-width: ${breakpoints.lg}) {
    max-width: ${PAGE_MAX_WIDTH}rem;
  }
`;

export const StyledSurveyWrapper = styled(Row)`
  height: 1rem;
  margin: 2rem 0 1.5rem 0;
  justify-content: flex-start;
`;

export const StyledSurvey = styled(SkeletonElement)``;
